package com.essntl.core.unsplash.ui

import com.essntl.core.unsplash.domain.UnsplashClient
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getPaginationData
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.async
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.collect
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class UnsplashViewModel(
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
    private val unsplashClient: UnsplashClient,
    val state: MutableStateFlow<UnsplashState> = MutableStateFlow(UnsplashState()),
) : ViewModel {

    init {
        scope.launch {
            state.collect { currentState ->
                if (currentState.getAllPicture.isFailure && currentState.getAllPicture.error != null) {
                    println("Error in getAllPicture: ${currentState.getAllPicture.error}")
                }
            }
        }
    }
    private fun getNextPicturePage(query: String) =
        getPaginationData(
            getData = {
                val nextPage = state.value.getAllPicture.loadedPages + 1L
                unsplashClient.searchPhotos(page = nextPage, query = query)
            },
            getState = { state.value.getAllPicture },
            setState = {
                state.value = state.value.copy(getAllPicture = it)
            },
        )

    fun onEvent(event: UnsplashEvent) {
        when (event) {
            is UnsplashEvent.LoadMorePicture -> {
                scope.launch {
                    async {
                        if (event.query != state.value.getAllPicture.query) {
                            state.update {
                                it.copy(
                                    getAllPicture = PaginationState(
                                        query = event.query,
                                    ),
                                )
                            }
                        }
                    }.await()
                    getNextPicturePage(event.query)
                }
            }
        }
    }
}
